import { render } from "./VehicleWithdrawalFormModal.vue?vue&type=template&id=bfc8fee0"
import script from "./VehicleWithdrawalFormModal.vue?vue&type=script&lang=ts"
export * from "./VehicleWithdrawalFormModal.vue?vue&type=script&lang=ts"

const cssModules = script.__cssModules = {}
import style0 from "./VehicleWithdrawalFormModal.vue?vue&type=style&index=0&id=bfc8fee0&module=true&lang=scss"
cssModules["$style"] = style0
script.render = render

export default script
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSpinner from 'quasar/src/components/spinner/QSpinner.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QForm from 'quasar/src/components/form/QForm.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QSlideTransition from 'quasar/src/components/slide-transition/QSlideTransition.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QSelect from 'quasar/src/components/select/QSelect.js';
import QCheckbox from 'quasar/src/components/checkbox/QCheckbox.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';import Ripple from 'quasar/src/directives/Ripple.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QSpinner,QList,QItem,QItemSection,QForm,QSeparator,QSlideTransition,QIcon,QInput,QSelect,QCheckbox,QToggle,QCardActions,QBtn});qInstall(script, 'directives', {Ripple});
